import { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import { addComma, HOSTNAME, isExternalUrl, numberToKorean } from '@src/utils';
import budgetAnimation from './budget_last.json';
import budgetSmallAnimation from './budget_small.json';
import budget_icon from './ic_budget_banner.png';
import { getMyBudgetInfo } from '@src/api/budget/budget';
import './budgetBanner.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@src/store';
import { useBroadcastChannel } from '@src/utils/hooks/useBroadcastChannel';
import { setBudgetType } from '@src/@slice/budgetSlice';
// import { Icon } from "@src/shared/src";
import Icon from "@src/components/common/icons/Icon";

const BudgetBanner = () => {
  const dispatch = useDispatch();
  const budgetType = useSelector((state: RootState) => state.budget);
  const [isOpen, setIsOpen] = useState(true);
  const [budgetSummary, setBudgetSummary] = useState({totalPlannedAmount:0, totalUsedAmount:0, totalRemainingAmount:0});

  const { broadcastMessage: broadcastPurchaseMessage } = useBroadcastChannel(
    "budgetPurchaseList",
    (e: MessageEvent) => {
      // 예산 타입 변경 메시지 수신 -> 예산 현황 조회
      if (e?.data?.type === "updateBudgetType") {
        getMyBudgetInfo()
        .then(res => {
          if(res.item.type){
            setBudgetSummary({
              totalPlannedAmount: res.item.totalPlannedAmount, 
              totalUsedAmount: res.item.totalUsedAmount, 
              totalRemainingAmount: res.item.totalRemainingAmount
            });
          }
        })
      }
       // 구매내역 변경 메시지 수신 -> 예산 현황 조회
      if (e?.data?.type === "updatePurchaseList") {
        getMyBudgetInfo()
        .then(res => {
          if(res.item.type){
            setBudgetSummary({
              totalPlannedAmount: res.item.totalPlannedAmount, 
              totalUsedAmount: res.item.totalUsedAmount, 
              totalRemainingAmount: res.item.totalRemainingAmount
            });
          }
        })
      }
    },
  );
  

  useEffect(()=>{
      getMyBudgetInfo()
      .then(res => {
        dispatch(setBudgetType(res.item.type));
        setBudgetSummary({
          totalPlannedAmount: res.item.totalPlannedAmount, 
          totalUsedAmount: res.item.totalUsedAmount, 
          totalRemainingAmount: res.item.totalRemainingAmount
        });
      })
  },[budgetType.type])

  return (
    <div className='budget-banner-wrap'>
    {!!budgetType.type === false?
      <div className={`budget-lottie-banner ${isOpen ? '' : 'closed'}`}
          onClick={() => window.location.href = isExternalUrl(`${HOSTNAME}/budget/home?hidetop=true`)}
      >
        {isOpen ?
        <>    
          <Lottie animationData={budgetAnimation} loop={true} />
            <div className='xbtn-overwrap' 
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false)
                }}>
              <Icon name="Close" size={24}/>
            </div>
        </>
          :
        <div className='budget-lottie-banner-small'>
          <Lottie animationData={budgetSmallAnimation} loop={true} />
          <i className='icon icon-18 icon-chevron-down-gray900' 
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(true)
            }}
          />
        </div>
        }
      </div>
    :
      <div className="page-budget-home">
        {isOpen ? 
          <BudgetDashboard setIsOpen={setIsOpen} budgetSummary={budgetSummary} title='나의 예산 현황' type='dashboard'/>
          :
          <div style={{padding:'0 20px'}}>
            <BudgetSmallBanner title='나의 예산 현황' setIsOpen={setIsOpen}/>
          </div>

        }
      </div>
    }
    </div>
  );
};

export default BudgetBanner;



const BudgetSmallBanner = ({title, setIsOpen}) => {
  return (
    <div className={`budget-banner-small`}>
      <p className='bold'>
        <img src={budget_icon} alt="budget_icon"  className='icon icon-size-auto'/>
        {title}
      </p>
      <i className='icon icon-18 icon-chevron-down-gray900' 
        onClick={() => setIsOpen(true)}/>
    </div>
  )
}


export const BudgetDashboard = ({
  setIsOpen, 
  budgetSummary,
  title,
  type
}:{
    setIsOpen?: (isOpen: boolean) => void, 
    budgetSummary?: {totalPlannedAmount: number, totalUsedAmount: number, totalRemainingAmount: number}, 
    title: string | null,
    type?: 'preview' | 'dashboard' //preview 는 로그인 안하거나 예산 설정 X인 경우, dashboard 는 예산 설정한 고객 요약본
  }) => {

  const budgetMoney = (budget: number) => {   
    return budget < 0 ? '0원' : addComma(budget)+'원'
  }
  return (
    <>
      {title === null && <div className="bold common-wrap" style={{fontSize: '18px', margin: '12px 0 22px 0'}}>내게 맞는 결혼 예산 추천 받기</div>}
      
      <div className="budget-dashboard-wrap">
        {title && 
        <h2 className="bold">
          <img src={budget_icon} alt="budget_icon" className='icon icon-size-auto'/>
          {title}
          <i className='icon icon-18 icon-chevron-up-gray900'
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen && setIsOpen(false)
            }}
          />
        </h2>}
        {type === 'dashboard' &&
          <>      
            <div className='new-budget-dashboard'  onClick={()=> window.location.href = isExternalUrl(`${HOSTNAME}/budget/home?hidetop=true`)}>
              <p className='bold'>총 사용 금액</p>
              <p>
                <span className='bold used-amount'>{budgetMoney(budgetSummary?.totalUsedAmount)}</span>
                <span  className='total-amount'>{`  / 총 예산 ${budgetMoney(budgetSummary?.totalPlannedAmount)}`}</span>
              </p>
            </div>
            <div className='btn btn-full btn-medium btn-gray200'
              onClick={()=> window.location.href = isExternalUrl(`${HOSTNAME}/budget/home?hidetop=true`)}
            >
              <p>앞으로 <strong>{budgetMoney(budgetSummary?.totalRemainingAmount)}</strong> 쓸 수있어요!</p>
              <Icon name="ChevronRight" size={18} />
            </div>
          </>
        }
        {type === 'preview' &&
        <>
          <div className="pie-graph-wrap">
            {/* {!!budgetSummary === false ?  */}
            <div className="donut" style={{ background: `conic-gradient(#A6A6A6 70%, #E6E6E6 0)` , height:'100px', marginBottom:'10px',marginTop:'10px'}}/>
            {/* :
            <div className="donut" style={{ background: `conic-gradient(#FE4B4C ${(budgetSummary.totalUsedAmount / budgetSummary.totalPlannedAmount) * 100 || 0}%, #E6E6E6 0)` , height:'100px'}}/>  
            } */}
            <div>
              <p style={{color: '#8A8A8A'}}>나의 예산</p>
              {/* {!!budgetSummary === false ?  */}
              <>
                <p className={`left-cost`}>???만원</p>
                <span style={{color: '#8A8A8A'}}>예산 평균을 알려드려요</span>
              </>
              {/* :
              <>
                <p className={`left-cost ${(budgetSummary?.totalPlannedAmount - budgetSummary?.totalUsedAmount) < 0 ? 'warning' :'' }`}>{addComma(budgetSummary?.totalPlannedAmount-budgetSummary.totalUsedAmount)}원</p>
                {budgetSummary?.totalUsedAmount === 0 ?
                <span>예산을 시작할까요?</span>
                :  
                <span>{(budgetSummary?.totalUsedAmount / budgetSummary?.totalPlannedAmount) * 100 > 100 ? '예산을 초과했어요!': '너무 잘하고 있어요!'}</span>}
              </>
              } */}
            </div>
          </div>
          <button 
            className="btn btn-full btn-red500 btn-medium" 
            style={{marginBottom:!!budgetSummary === false  ? '14px' : '0', textAlign:'center', display:'block'}}
            onClick={()=> window.location.href = isExternalUrl(`${HOSTNAME}/budget/home?hidetop=true`)}
            >{!!budgetSummary === false ? '예산 설정하기' : '예산 자세히 보기'}</button>
        </>
        }
      </div>
    </>
  )
}